import { IconButton, Tooltip } from '@chakra-ui/react'
import { CopyIcon, ExternalLinkIcon } from '@chakra-ui/icons'
import { useClipboard } from '@chakra-ui/react'
import { getExplorerAddressUrl, getExplorerTxUrl } from '@/utils/formatUtils'

interface CopyIconButtonProps {
  value?: string
  label: string
  size?: string
}

export const CopyIconButton = ({ value, label, size = 'xs' }: CopyIconButtonProps) => {
  const clipboard = useClipboard(value ?? '')
  if (!value) {
    return null
  }
  return (
    <IconButton
      size={size}
      variant='ghost'
      aria-label={label}
      icon={<CopyIcon />}
      onClick={clipboard.onCopy}
      colorScheme={clipboard.hasCopied ? 'green' : 'gray'}
    />
  )
}

interface ExplorerButtonProps {
  type: 'tx' | 'address'
  value?: string | null
  chainId?: string | number | null
}

export const ExplorerButton = ({ type, value, chainId }: ExplorerButtonProps) => {
  if (!value) {
    return null
  }
  const url =
    type === 'tx'
      ? getExplorerTxUrl(chainId ?? null, value)
      : getExplorerAddressUrl(chainId ?? '', value)
  if (!url) {
    return null
  }
  return (
    <Tooltip label={type === 'tx' ? 'Explorer TX' : 'Explorer Address'} openDelay={300}>
      <IconButton
        as="a"
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        size="xs"
        variant="ghost"
        aria-label={type === 'tx' ? 'Explorer TX' : 'Explorer Address'}
        icon={<ExternalLinkIcon />}
      />
    </Tooltip>
  )
}
